import './logo.scss';
import LOGO_OTL_LIGHT from '../../assets/svg/logo_OTL_light_letters.svg';
import LOGO_OTL_DARK from '../../assets/svg/logo_OTL_dark_letters.svg';
import LOGO_SC_LIGHT from '../../assets/svg/logo_SC_light_letters.svg';
import LOGO_SC_DARK from '../../assets/svg/logo_SC_dark_letters.svg';
import { useTheme } from '../../../app/contexts/theme/theme.context';

const LOGOS: any = {
    'smart-cargas': {
        alt: 'Logo Smart Cargas',
        className: 'sc-logo',
        light: LOGO_SC_DARK,
        dark: LOGO_SC_LIGHT,
    },
    'ontime-leilao': {
        alt: 'Logo Ontime Leilão',
        className: 'otl-logo',
        light: LOGO_OTL_DARK,
        dark: LOGO_OTL_LIGHT,
    },
    default: {
        alt: 'Logo default',
        className: 'default-logo',
        light: LOGO_SC_DARK,
        dark: LOGO_SC_LIGHT,
    },
};

function ReactFCComponent({
    system = 'default',
}: Readonly<{ system?: string }>) {
    const { theme } = useTheme();
    const logo = LOGOS[system];

    return (
        <img
            src={logo[theme]}
            alt={logo.alt}
            className={logo.className}
            data-testid="logo-image"
        />
    );
}

export default ReactFCComponent;
